import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';
import eventBus from '../../Shared/EventBus.js';

export default {
    name: 'Notifications',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canUseNotificationsUi()) {
            this.logout();
            return;
        }

        this.GetInfo();
        eventBus.$on('notifications:changed', this.handleNotificationsChanged);
    },

    beforeDestroy() {
        eventBus.$off('notifications:changed', this.handleNotificationsChanged);
    },

    data() {
        return {
            Info: [],
            pageNo: 1,
            pageSize: 20,
            pages: 0,
            unreadOnly: false
        };
    },

    methods: {
        handleNotificationsChanged() {
            this.GetInfo(this.pageNo);
        },

        GetInfo(page) {
            if (page) this.pageNo = page;

            this.$blockUI.Start();
            this.$http.GetNotifications(this.pageNo, this.pageSize, this.unreadOnly)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                });
        },

        async markRead(item, refreshList = true) {
            if (!item || item.isRead) {
                return;
            }

            try {
                await this.$http.MarkNotificationRead(item.id);
                item.isRead = true;
                eventBus.$emit('notifications:changed');
                if (refreshList) {
                    this.GetInfo(this.pageNo);
                }
            } catch {
                // Keep the row unchanged if the API call fails.
            }
        },

        async markAllRead() {
            try {
                this.$blockUI.Start();
                await this.$http.MarkAllNotificationsRead();
                this.$blockUI.Stop();
                eventBus.$emit('notifications:changed');
                this.GetInfo(this.pageNo);
            } catch {
                this.$blockUI.Stop();
            }
        },

        async openItem(item) {
            if (!item) return;

            if (!item.isRead) {
                await this.markRead(item, false);
            }

            const path = item.actionPath || '/Notifications';
            if (this.$route.path !== path) {
                this.$router.push(path);
            }
        },

        statusLabel(item) {
            return item && item.isRead ? 'مقروء' : 'غير مقروء';
        },

        categoryIcon(item) {
            const category = item && item.category ? item.category : 'general';
            if (category === 'inventory') return 'ti ti-alert-triangle';
            if (category === 'direct-dispatch') return 'ti ti-truck-delivery';
            if (category === 'receipt-verification') return 'ti ti-clipboard-check';
            if (category === 'medicine-order') return 'ti ti-package';
            return 'ti ti-bell';
        },

        categoryBadgeClass(item) {
            if (!item || item.isRead) return 'bg-label-secondary';
            return 'bg-label-primary';
        }
    }
};
